(() => {
  if (customElements.get('sw-cart-offer')) return;
  class CartOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-offer-variants]').textContent);
      this.selects = [...this.querySelectorAll('[data-offer-option]')];
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="status"]');
      this.querySelector('form').addEventListener('change', () => this.update());
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); this.add(); });
      this.update();
    }
    update() {
      this.variant = this.variants.find(v => this.selects.every((s,i) => v.options[i] === s.value));
      const v = this.variant;
      this.button.disabled = this.busy || !v?.available;
      this.button.textContent = v?.available ? window.nuashapeI18n.dynamic_002 : window.nuashapeI18n.dynamic_003;
      if (!v) return;
      this.querySelector('[data-offer-price]').textContent = v.price;
      const compare = this.querySelector('[data-offer-compare]');
      compare.hidden = !v.compare; compare.textContent = v.compare || '';
      const img = this.querySelector('img');
      if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
    }
    async add() {
      if (this.busy || !this.variant?.available) return;
      this.busy = true; this.button.disabled = true; this.button.textContent = window.nuashapeI18n.dynamic_006;
      this.error.hidden = true;
      const drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const sections = drawer.getSectionsToRender().map(s => s.id);
        // The clicked card disappears after addition; return focus to a persistent drawer control.
        drawer.setActiveElement(document.querySelector('[data-sw-cart]') || document.querySelector('a[href$="/cart"]'));
        const response = await fetch(root + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:this.variant.id,quantity:1}],sections,sections_url:location.pathname})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || window.nuashapeI18n.dynamic_007);
        added = true;
        if (!data.sections?.['cart-drawer']) {
          const rendered = await fetch(root + '?sections=' + sections.join(','));
          if (!rendered.ok) throw new Error(window.nuashapeI18n.dynamic_022);
          data.sections = await rendered.json();
        }
        if (!data.sections?.['cart-drawer']) throw new Error(window.nuashapeI18n.dynamic_022);
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        drawer.querySelector('.drawer__close')?.focus();
        this.busy = false; this.update();
      } catch (error) {
        this.error.hidden = false;
        this.error.textContent = added ? window.nuashapeI18n.dynamic_023 : error.message;
        // Do not repeat a successful add if only section rendering failed.
        if (added) { this.button.textContent = window.nuashapeI18n.dynamic_024; return; }
        this.busy = false; this.update();
      }
    }
  }
  customElements.define('sw-cart-offer', CartOffer);
})();

if (!customElements.get('sw-product-cross-sell')) {
  customElements.define('sw-product-cross-sell', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.sw-product-cross-sell__track');
      const prev = this.querySelector('[data-cross-prev]');
      const next = this.querySelector('[data-cross-next]');
      const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
      [prev, next].forEach((button, index) => button.addEventListener('click', () => track.scrollBy({left:(index ? 1 : -1) * (track.firstElementChild.getBoundingClientRect().width + 10),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'})));
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update); this.observer.observe(track); update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
